import {
    CustomerTestimonials,
    TestimonialProps
} from "@/libraries/design/patterns/customer-testimonials/src/customer-testimonials";

export type UniformCustomerTestimonialsProps = {
    theme: "black" | "white";
    quotes: {
        fields: {
            organization: {
                fields: {
                    organizationNameExternal: string;
                    logo: {
                        fields: UniformContentfulImage;
                    }[];
                };
            };
            advocateName: string;
            advocateJobTitle: string;
            advocateHeadshot: {
                fields: UniformContentfulImage;
            };
            advocateQuote: string;
        };
    }[];
};

type UniformContentfulImage = {
    file: {
        contentType: "string";
        url: string;
        details: {
            image: {
                width: number;
                height: number;
            };
        };
    };
};

const transformImage = (props: UniformContentfulImage, alt?: string) => {
    if (!props) {
        return undefined;
    }
    return {
        contentType: props.file?.contentType,
        src: props.file?.url,
        alt: alt ?? "",
        baseWidth: 500,
        width: props.file?.details?.image?.width,
        height: props.file?.details?.image?.height
    };
};
const transformProps = (props: UniformCustomerTestimonialsProps) => {
    return {
        bgColor: props.theme ?? "white",
        testimonials: props.quotes.map((quote) => {
            const fields = quote.fields;

            return {
                logo: transformImage(
                    fields.organization?.fields?.logo?.[0]
                        ?.fields as UniformContentfulImage,
                    fields.organization?.fields?.organizationNameExternal
                ),
                name: fields.advocateName,
                title: fields.advocateJobTitle,
                image: transformImage(fields.advocateHeadshot?.fields),
                quote: fields.advocateQuote,
                link: undefined
            } as TestimonialProps;
        })
    };
};

const UniformCustomerTestimonials = (
    props: UniformCustomerTestimonialsProps
) => {
    //TODO GWP-6313: add CTA links, and ensure they are localized in each panel

    const transformed = transformProps(props);

    return (
        <CustomerTestimonials
            bgColor={transformed.bgColor}
            testimonials={transformed.testimonials}
        />
    );
};

export default UniformCustomerTestimonials;
